// extracted by mini-css-extract-plugin
module.exports = {"date":"date_renderer_date_2MYJl","error":"date_renderer_error_1_UJG"};